<template>
    <b-container class="p-0">
        <b-modal centered id="choose_answer_modal" hide-footer hide-header>
            <b-row class="correct-answer mx-lg-3">
                <b-col cols="6" class="correct-answer-item mb-3" @click="answerChoose(index)" v-for="(item, index) in qdata.correctAnswer.items" :key="index">
                    <b-card no-body>
                        <div class="correct-item__image">
                            <img class="mw-100" :src="imageSrc(item.image)" alt="">
                        </div>
                        <div class="correct-item__label text-center p-1">
                            <strong>{{ item.label.value }}</strong>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-modal>
        <div class="lt-detail">
            <b-row class="mt-4">
                <b-col>
                    <div class="question-example">
                        <p class="text-start section-title mb-0"><strong>Example</strong></p>
                        <div class="example__block border p-2 rounded">
                            <b-row style="font-size: 1.3rem;" v-if="!qdata.example">
                                <b-col>
                                    <img style="max-height: 200px" class="mw-100" :src="exampleImage" alt="">
                                </b-col>
                                <b-col class="d-flex justify-content-center align-items-center">
                                    <p class="m-0">mum</p>
                                </b-col>
                                <b-col class="d-flex justify-content-center align-items-center">
                                    <div class="answer-choose text-center">
                                        <strong>B</strong>
                                    </div>
                                </b-col>
                            </b-row>
                            <div v-if="qdata.example">
                                <b-row style="font-size: 1.3rem;" class="correct-answer" v-for="(item, index) in qdata.example" :key="index">
                                    <b-col>
                                        <img class="mw-100" style="max-height: 200px" :src="imageSrc(item.image.data)" alt="">
                                    </b-col>
                                    <b-col class="d-flex justify-content-center align-items-center">
                                        <p class="m-0">{{ item.text.data.value }}</p>
                                    </b-col>
                                    <b-col class="d-flex justify-content-center align-items-center">
                                        <div class="answer-choose text-center">
                                            <strong>{{ qdata.correctAnswer.items[item.answer].label.value }}</strong>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col cols="12">
                    <p class="text-start section-title mb-0"><strong>Questions</strong></p>
                </b-col>
                <b-col lg="6">
                    <b-row class="correct-answer" style="font-size: 1.3rem;">
                        <b-col lg="4" cols="6" md="6" class="correct-answer-item mb-3" v-for="(item, index) in qdata.correctAnswer.items" :key="index">
                            <b-card no-body>
                                <div class="correct-item__image">
                                    <img class="mw-100" :src="imageSrc(item.image)" alt="">
                                </div>
                                <div class="correct-item__label text-center p-1">
                                    <strong>{{ item.label.value }}</strong>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col lg="6">
                    <b-row class="correct-answer mb-3" v-for="(item, index) in qdata.question" :key="index" @click="chooseAnswer(index)">
                        <b-card no-body class="p-0">
                            <b-row style="font-size: 1.3rem;">
                                <b-col>
                                    <img class="mw-100" :src="imageSrc(item.image.data)" alt="">
                                </b-col>
                                <b-col class="d-flex justify-content-center align-items-center">
                                    <p class="m-0">{{ item.text.data.value }}</p>
                                </b-col>
                                <b-col class="d-flex justify-content-center align-items-center">
                                    <div class="answer-choose text-center">
                                        <strong>{{ item.choose }}</strong>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>

import {
    BRow,
    BCol,
    BModal,
    BCard,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'lt_detail',
    components: {
        BRow,
        BCol,
        BCard,
        BContainer,
        BModal
    },
    props: {
        qdata: Object
    },
    created() {
        if (this.qdata.question) {
            for (let index = 0; index < this.qdata.question.length; index++) {
                // .choose == ''
                this.$set(this.qdata.question[index], 'choose', '')
                this.answer[index] = null
            }
        }
    },
    data() {
        return {
            answer: [],
            imageDefault: require('@/assets/img-default.jpg'),
            exampleImage: require('@/assets/kidbox-example/lt_detail.png'),
            questionChooseAnswer: null,
        }
    },
    methods: {
        answerChoose(index) {
            this.answer[this.questionChooseAnswer] = index
            if (this.qdata.question) {
                this.qdata.question[this.questionChooseAnswer].choose = this.qdata.correctAnswer.items[index].label.value
            }
            this.$emit('input', {
                answers: this.answer,
            })
            this.$bvModal.hide('choose_answer_modal')
        },
        chooseAnswer(index) {
            this.questionChooseAnswer = index
            this.$bvModal.show('choose_answer_modal')
        },
        imageSrc (data) {
            if (data && data?.src !== '') { return data.src }
            return this.imageDefault
        },
        lableOfQuestion (index) {
            return this.answer[index]
        },
    },
    watch: {
        answer : {
            handler(value) {
                this.$emit('input', {
                    answers: value,
                })
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.answer-choose {
    height: 40px;
    width: 40px;
    border: 2px solid #000;
    cursor: pointer;
}
</style>